import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const AboutContainer = styled(Box)(({ theme }) => ({
  padding: '6rem 0',
  backgroundColor: '#f8fafc',
  position: 'relative'
}));

const AboutContent = styled(Container)(({ theme }) => ({
  textAlign: 'center'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '3rem',
  fontWeight: 700,
  marginBottom: '1.5rem',
  color: '#1e293b',
  [theme.breakpoints.down('md')]: {
    fontSize: '2.5rem'
  }
}));

const SectionDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  color: '#64748b',
  maxWidth: '800px',
  margin: '0 auto',
  lineHeight: 1.7,
  fontWeight: 400
}));

const FeatureGrid = styled(Grid)(({ theme }) => ({
  marginTop: '4rem'
}));

const FeatureCard = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  padding: '2rem',
  borderRadius: '16px',
  backgroundColor: 'white',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  height: '100%',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
  }
}));

const FeatureIcon = styled(Box)(({ theme }) => ({
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  backgroundColor: '#3b82f6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 1.5rem auto',
  fontSize: '2rem',
  color: 'white'
}));

const FeatureTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 600,
  marginBottom: '1rem',
  color: '#1e293b'
}));

const FeatureDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#64748b',
  lineHeight: 1.6
}));

const AboutSection = ({ description }) => {
  const features = [
    {
      icon: '🎯',
      title: 'Expert Solutions',
      description: 'Tailored strategies and solutions designed specifically for your business needs and goals.'
    },
    {
      icon: '⚡',
      title: 'Fast Delivery',
      description: 'Quick turnaround times without compromising on quality or attention to detail.'
    },
    {
      icon: '🛡️',
      title: 'Reliable Support',
      description: '24/7 customer support to ensure your business operations run smoothly at all times.'
    }
  ];

  return (
    <AboutContainer>
      <AboutContent maxWidth="lg">
        <SectionTitle variant="h2">
          About Our Business
        </SectionTitle>
        <SectionDescription variant="body1">
          {description || 'We are dedicated to providing exceptional services and products tailored to your needs. Our team of experts works tirelessly to ensure your success and satisfaction.'}
        </SectionDescription>
        
        <FeatureGrid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <FeatureCard>
                <FeatureIcon>
                  {feature.icon}
                </FeatureIcon>
                <FeatureTitle variant="h6">
                  {feature.title}
                </FeatureTitle>
                <FeatureDescription variant="body2">
                  {feature.description}
                </FeatureDescription>
              </FeatureCard>
            </Grid>
          ))}
        </FeatureGrid>
      </AboutContent>
    </AboutContainer>
  );
};

export default AboutSection;
